import React, { useState, useEffect } from "react";

function MainBtnNotDisabled(props) {
  const [hover, setHover] = useState(false);

  return (
    <>
      <div
        onClick={props.disabled ? null : props.onClick}
        onMouseEnter={() => setHover(true)} // 마우스엔터(호버)시 키값이 저장된다
        onMouseLeave={() => setHover(false)} // 마우스리브 시에는 키값이 지워진다
        style={{
          background: props.disabled
            ? "#2C2C33"
            : hover
            ? "#7E53FF"
            : "#2C2C33",
          width: "100%",
          cursor: "pointer",
          height: 49,
          borderRadius: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          ...props.style,
        }}
      >
        {props.children}
      </div>
    </>
  );
}

export default MainBtnNotDisabled;
